<div class="page-layout carded left-sidenav">
  <!-- toolbar -->
  <mat-sidenav-container>
    <mat-sidenav class="sidenav pdf-navigation" position="start" opened="true" mode="side"
                 fuseMatSidenavHelper="carded-left-sidenav" mat-is-locked-open="gt-md">
      <mat-accordion>
        <mat-expansion-panel expanded *ngFor="let itemGroup of itemGroups">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ itemGroup.groupTitle }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <mat-list>
            <mat-list-item *ngFor="let item of itemGroup.items">
              <a (click)="clicked(item)" [ngClass]="{'active': item.isActive===true}"> {{item.title}}</a>
            </mat-list-item>
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>

    </mat-sidenav>
    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <!-- CONTENT -->
        <div class="content flex flex-col" fusePerfectScrollbar>

          <div class="pdfcontainer flex flex-row" *ngIf="loaded">
            <particle-platform-pdf-viewer [stream]="stream" (downloadPdf)="downloadPdf($event)"
                                          [sidenavToggleDisabled]="false">

            </particle-platform-pdf-viewer>
          </div>
        </div>
        <!-- / CONTENT -->

      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
